// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type PathwayEnrolmentDetailAnalyticsQueryVariables = PrivateSchemaTypes.Exact<{
  enrolmentId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type PathwayEnrolmentDetailAnalyticsQuery = (
  { __typename?: 'Query' }
  & { pathwayEnrolment?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'PathwayEnrolmentModelAsAdmin' }
    & Pick<PrivateSchemaTypes.PathwayEnrolmentModelAsAdmin, 'id' | 'progress' | 'status' | 'created_at' | 'completed_at' | 'started_at' | 'importedAt' | 'deleted_at'>
    & { topics: Array<(
      { __typename?: 'TopicModelAsEditor' }
      & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
      & { currentTopicVersion?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicVersionModelAsEditor' }
        & Pick<PrivateSchemaTypes.TopicVersionModelAsEditor, 'title' | 'version'>
      )>, author: (
        { __typename?: 'UserModelPublicBase' }
        & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name' | 'image_url'>
      ) }
    )>, topicEnrolments: Array<(
      { __typename?: 'TopicEnrolmentModelAsStudent' }
      & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'id' | 'topic_id' | 'progress' | 'start_date' | 'completion_date' | 'auto_correct' | 'pass_mark' | 'status' | 'available_points' | 'attempt'>
      & { topicVersion?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicVersionModel' }
        & Pick<PrivateSchemaTypes.TopicVersionModel, 'title' | 'version' | 'max_attempts' | 'allow_retry'>
      )> }
    )>, importRecord?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'PathwayEnrolmentImportedModel' }
      & Pick<PrivateSchemaTypes.PathwayEnrolmentImportedModel, 'id' | 'source_name'>
      & { importedBy?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'UserModelBase' }
        & Pick<PrivateSchemaTypes.UserModelBase, 'id' | 'display_name' | 'image_url'>
      )> }
    )>, pathway?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'PathwayModelAsStudent' }
      & Pick<PrivateSchemaTypes.PathwayModelAsStudent, 'id' | 'progress' | 'title' | 'deleted_at'>
    )>, pathwayVersion?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'PathwayVersionModel' }
      & Pick<PrivateSchemaTypes.PathwayVersionModel, 'version'>
    )>, sharedBy?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'UserModelBase' }
      & Pick<PrivateSchemaTypes.UserModelBase, 'id' | 'display_name' | 'image_url'>
    )>, user: (
      { __typename?: 'UserModelAsAdminQueries' }
      & Pick<PrivateSchemaTypes.UserModelAsAdminQueries, 'id' | 'display_name' | 'image_url'>
    ) }
  )> }
);


export const PathwayEnrolmentDetailAnalyticsDocument = gql`
    query pathwayEnrolmentDetailAnalytics($enrolmentId: PositiveInt!) {
  pathwayEnrolment(id: $enrolmentId) {
    id
    progress
    status
    created_at
    completed_at
    started_at
    importedAt
    deleted_at
    topics {
      id
      currentTopicVersion: currentTopicVersionAsEditor {
        title
        version
      }
      author {
        id
        display_name
        image_url
      }
    }
    topicEnrolments {
      id
      topic_id
      progress
      start_date
      completion_date
      auto_correct
      pass_mark
      status
      available_points
      attempt
      topicVersion {
        title
        version
        max_attempts
        allow_retry
      }
    }
    importRecord {
      id
      source_name
      importedBy {
        id
        display_name
        image_url
      }
    }
    pathway {
      id
      progress
      title
      deleted_at
    }
    pathwayVersion {
      version
    }
    sharedBy {
      id
      display_name
      image_url
    }
    user {
      id
      display_name
      image_url
    }
  }
}
    `;

/**
 * __usePathwayEnrolmentDetailAnalyticsQuery__
 *
 * To run a query within a React component, call `usePathwayEnrolmentDetailAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathwayEnrolmentDetailAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathwayEnrolmentDetailAnalyticsQuery({
 *   variables: {
 *      enrolmentId: // value for 'enrolmentId'
 *   },
 * });
 */
export function usePathwayEnrolmentDetailAnalyticsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PathwayEnrolmentDetailAnalyticsQuery, PathwayEnrolmentDetailAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PathwayEnrolmentDetailAnalyticsQuery, PathwayEnrolmentDetailAnalyticsQueryVariables>(PathwayEnrolmentDetailAnalyticsDocument, options);
      }
export function usePathwayEnrolmentDetailAnalyticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PathwayEnrolmentDetailAnalyticsQuery, PathwayEnrolmentDetailAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PathwayEnrolmentDetailAnalyticsQuery, PathwayEnrolmentDetailAnalyticsQueryVariables>(PathwayEnrolmentDetailAnalyticsDocument, options);
        }
export type PathwayEnrolmentDetailAnalyticsQueryHookResult = ReturnType<typeof usePathwayEnrolmentDetailAnalyticsQuery>;
export type PathwayEnrolmentDetailAnalyticsLazyQueryHookResult = ReturnType<typeof usePathwayEnrolmentDetailAnalyticsLazyQuery>;
export type PathwayEnrolmentDetailAnalyticsQueryResult = Apollo.QueryResult<PathwayEnrolmentDetailAnalyticsQuery, PathwayEnrolmentDetailAnalyticsQueryVariables>;